// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-notfound img{max-width:100px;margin-bottom:30px}.page-notfound .btn{margin-top:30px}.page-notfound .container{display:flex;align-items:center;justify-content:center;text-align:center}", ""]);
// Exports
module.exports = exports;
